import { createClient } from '@supabase/supabase-js'

// ─── FICIO SUPABASE CLIENT ────────────────────────────────────────────────────
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://javrjvjihudorashqfob.supabase.co'
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImphdnJqdmppaHVkb3Jhc2hxZm9iIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgyNjYxMzMsImV4cCI6MjA5Mzg0MjEzM30.NLyD6WhwAJzq4qqsRYBv6qdCBOuUwk_VxtcCVibRPK4'

export const supabase = createClient(
  supabaseUrl,
  supabaseKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storageKey: 'ficio-auth-session'
    }
  }
)
